import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    public authService: AuthenticationService,
    public router: Router
  ) {}

  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['auth', 'login']);
    //   this.router.navigateByUrl('/auth/login');
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/+auth/common/services/auth-guard.service.ts